import { TextField, InputAdornment, IconButton } from "@material-ui/core";
import translate from "../../../../i18n/translate";
import * as React from "react";
import { SearchIcon } from "../../../common/icon";

const SearchBar = ({
  searchText,
  setSearchText,
  changeClassName,
  handleSearch,
  isNotVocabCenterPage,
  searchOnly,
}: any) => {
  const WORD_REGEX = /^[ A-Za-z0-9()-.:;?!&']*$/;
  const [showError, setShowError] = React.useState<boolean>(false);
  return (
    <div
      data-testid="search"
      className={
        isNotVocabCenterPage
          ? "vocabulary-center-wordlist-search-box"
          : `vocabulary-center-search-box ${changeClassName}`
      }
    >
      <TextField
        className={isNotVocabCenterPage ? "vocabulary-center-wordlist-search-input" : "vocabulary-center-search-input"}
        value={searchText}
        onChange={(e) => {
          setShowError(!WORD_REGEX.test(e.target.value));
          setSearchText(e.target.value);
        }}
        onKeyPress={handleSearch}
        id="outlined-basic"
        label={searchOnly ? translate("search") : translate("vocab_center_search_word")}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton id="search-button" type="button" onClick={handleSearch} aria-label="search">
                <SearchIcon id="search-button" />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      {showError && <p className="new-word-error-message">Please enter a-z, A-Z, 0-9,()-., ;:?, !&'</p>}
    </div>
  );
};

export default SearchBar;
